<template>
  <div class="d-flex align-center">
    <div style="text-align: right;">
      <SubHeader v-if="title" :color="color"  :text="title" :small="smallLabel" :componentStyle="additionalSmallHeading? 'line-height: 14px!important; height: 20px;': undefined"/> 
     
      <template v-if="additionalSmallHeading">
        <small class="box-item__small-additional" :style="`color: ${color};`">
          {{ additionalSmallHeading }}
        </small>
      </template>
    </div>
    <span v-if="required && showRequiredSymbol" style="color: red">&nbsp;*</span>
    <template v-if="!onlyTitle">
      <template v-if="hasItems || forceSelectType">
        <v-select
          v-model="currentValue"
          :rules="rules"
          :dense="dense"
          :error="hasError"
          :errorMessage="errorMessage"
          :style="`${customStyle}`"
          :required="required"
          :item-value="itemsValue"
          :item-text="itemsText"
          :readonly="readOnly"
          :color="color"
          :clearable="clearable"
          class="box-item__select"
          :items="items"
        />
      </template>
      <template v-else-if="isSwitchField">
        <v-switch v-model="currentValue" :dense="dense" 
          :style="`${customStyle}`" class="box-item__switch"></v-switch>
      </template>
      <template v-else-if="isDateField">
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="currentValue"
              style="padding-left: 12px;"
              :label="label"
              persistent-hint
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="currentValue"
            no-title
            @input="dateMenu = false"
          ></v-date-picker>
        </v-menu>
      </template>
      <template v-else>
        <v-text-field
          v-if="!isPasswordField"
          :oninput="oninput"
          :dense="dense"
          :style="`${customStyle}`"
          :type="type"
          :min="min"
          :hint="hint"
          :error="hasError"
          :errorMessages="errorMessage"
          :readonly="readOnly"
          :required="required"
          :rules="rules"
          :color="color"
          v-model="currentValue"
          class="box-item__textfield"
        />
        <v-text-field
          v-else
          class="box-item__textfield"
          :oninput="oninput"
          :style="`${customStyle}`"
          :error="hasError"
          :errorMessage="errorMessage"
          :dense="dense"
          :required="required"
          :readonly="readOnly"
          :rules="rules"
          :color="color"
          v-model="currentValue"
          :type="type"
        />
      </template>
    </template>
  </div>
</template>

<script>
import SubHeader from "./SubHeader.vue";
import {cloneDeep} from 'lodash';

export default {
  name: "BoxItem",
  components: {
    SubHeader,
  },
  data() {
    return {
      currentValue: "",
      dateMenu: false,
    };
  },
  props: {
    title: {
      type: String,
    },
    additionalSmallHeading:{
      type: String,
      default: ''
    },
    showRequiredSymbol: {
      type: Boolean,
      default: false
    },
    dense:{
      type: Boolean,
      default: false
    },
    valueType:{
      type: String,
    },
    hasError: {
      type: Boolean
    },
    errorMessage: {
      type: String,
    },
    customStyle:{
      type: String,
      default: ''
    },
    onlyTitle: {
      type: Boolean,
      default: false,
    },
    forceSelectType: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemsValue: {
      type: String,
    },
    itemsText: {
      type: String,
    },
    value: {
      type: [String, null],
    },
    color: {
      type: String,
      default: "secondary",
    },
    rules: {
      type: Array,
    },
    required: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
    },
    min: {
      type: String,
    },
    oninput: {
      default: undefined,
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text",
    },
    smallLabel: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.setValue(this.value);
  },
  watch: {
    currentValue: {
      deep: true,
      handler(newValue, oldValue) {
        this.$emit("updateValue", newValue);
      },
    },
    value: {
      handler(newValue){
        this.setValue(newValue);
      },
      deep: true
    }
  },
  computed: {
    hasItems() {
      return this.items && this.items.length > 0;
    },
    isPasswordField() {
      return this.type === "password";
    },
    isSwitchField() {
      return this.type === "switch";
    },
    isDateField(){
      return this.type === 'date'
    }
  },
  methods:{
    setValue(value){
      if(this.valueType && this.valueType === 'boolean'){
        if(value === '0' || value === null){
          this.currentValue = false;
        }else if(value === '1'){
          this.currentValue = true;
        }else{
          this.currentValue = Boolean(cloneDeep(value));
        }
      }else{
        this.currentValue = cloneDeep(value);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.box-item {
  &__select,
  &__textfield {
    display: flex;
    flex: 1;
    padding: 0;
    max-width: 100%;
    margin-left: 0.75em;
    margin-right: 1em;
    &::v-deep > * {
      padding: 4px 0 2px;
    }
  }
  &__switch {
    display: flex;
    flex: 1;
    padding: 0;
    max-width: 100%;
    margin-left: 0.75em;
    margin-right: 1em;
    &::v-deep > * {
      padding: 0 0 2px;
    }
  }

  &__small-additional{
    float: none;
    clear: both;

  }
}


</style>
